





































    import { Component, Vue, Watch ,Prop} from 'vue-property-decorator';
    import 'swiper/dist/css/swiper.css'
    import $ from 'jquery';
    @Component(
        {
            components:{
            }
        }
    )
    export default class setMeal extends Vue {

        activeid = 1
        // ###################################
        async mounted () {
            // $('.img2').click((e)=>{
            //     console.log('ee',e);
                
            //     document.getElementsByClassName('img2')[0].className += ' imgall';
            // })
        }
        chooseactive(type){
            // $(`.img${type}`).removeClass("imgall"); 
            this.$nextTick(()=>{
                this.activeid = type 
                // $(`.img${type}`).addClass("imgall");  
            })
               
        }     
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/home/components/setMeal.vue